/****************************** Product Bundle ******************************/
const qties = document.querySelectorAll('input[type="number"][step]');

qties.forEach((qty) => {
  const step = parseInt(qty.getAttribute('step'), 10) || 1;
  const min = parseInt(qty.getAttribute('min'), 10) || step;
  const max = qty.getAttribute('max') ? parseInt(qty.getAttribute('max'), 10) : null;

  qty.addEventListener('blur', () => {
    let value = parseInt(qty.value, 10);

    if (isNaN(value) || value < min) {
      qty.value = min;
      return;
    }

    value = Math.ceil(value / step) * step;

    if (max !== null && value > max) {
      value = Math.floor(max / step) * step;
    }

    qty.value = value;
  });
});

function checkStock(el) {
  const qty = el.querySelector('input[type="number"]');

  let max = -1;
  if (qty.getAttribute('max')) {
    max = parseInt(qty.getAttribute('max'), 10);
  }

  let step = 1;
  if (qty.getAttribute('step')) {
    step = parseInt(qty.getAttribute('step'), 10);
  }

  const value = parseInt(qty.value, 10) || step;
  const nextValue = value + step;

  return max === -1 || nextValue <= max;
}

/****************************** Popup age ******************************/
const popupAge = document.querySelector('.section-age-verification-popup');
if (popupAge) {
    const popupAgeContainer = popupAge.querySelector('[id^="x-age-popup-"]');
    const reappearAfter = parseInt(popupAgeContainer?.dataset.reappearAfter || '7', 10);

    const popupAgeDeclineBtn = popupAge.querySelector('a.button');
    const popupAgeDeclineText = popupAge.querySelector('.decline-text');

    const stored = JSON.parse(localStorage.getItem('popupAgeDeclined'));
    const now = new Date();

    if (stored && new Date(stored.expiry) > now) {
        showDeclineState();
    }

    if (popupAgeDeclineBtn && popupAgeDeclineText) {
        popupAgeDeclineBtn.addEventListener('click', function (e) {
            e.preventDefault();
            showDeclineState();

            const expiry = new Date();
            expiry.setDate(expiry.getDate() + reappearAfter);
            localStorage.setItem('popupAgeDeclined', JSON.stringify({ expiry }));
        });
    }

    function showDeclineState() {
        const popupAgeText = popupAge.querySelector('[class*="content-text"] .p-break-words');
        if (popupAgeText) popupAgeText.style.display = 'none';
        if (popupAgeDeclineText) popupAgeDeclineText.style.display = 'block';
        if (popupAgeDeclineBtn?.parentNode) popupAgeDeclineBtn.parentNode.style.display = 'none';
    }
}
